import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { alpha, Box, LinearProgress, Typography, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
import InfoIconTooltip from '@ui/components/common/Tooltips/InfoIconTooltip';
const CapacityProgressBar = ({ label, current, max, infoTooltip }) => {
    const theme = useTheme();
    const primary = theme.palette.text.primary;
    const safeMax = max > 0 ? max : 0;
    const clampedCurrent = safeMax > 0 ? Math.min(current, safeMax) : 0;
    const percent = safeMax > 0 ? Math.min(100, parseFloat(((clampedCurrent / safeMax) * 100).toFixed(2))) : 0;
    const formattedCurrent = clampedCurrent.toLocaleString();
    const formattedMax = safeMax.toLocaleString();
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            minWidth: 0
        }, children: [_jsxs(Box, { sx: { flexShrink: 0, pr: '12px' }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 0.5 }, children: [_jsx(Typography, { variant: 'caption', sx: { color: theme.palette.common.grey.dark, display: 'block' }, children: label }), infoTooltip && (_jsx(InfoIconTooltip, { title: infoTooltip, size: 'small', variant: 'dark', icon: _jsx(Icon, { icon: 'hugeicons:information-circle', color: theme.palette.action.active, fontSize: 12, style: { pointerEvents: 'none' } }) }))] }), _jsxs(Typography, { variant: 'subtitle1', sx: { color: 'text.primary' }, children: [_jsx(Box, { component: 'span', sx: { fontWeight: 400 }, children: formattedCurrent }), _jsxs(Box, { component: 'span', sx: { fontWeight: 500 }, children: [' ', "/ ", formattedMax] })] })] }), _jsx(LinearProgress, { variant: 'determinate', value: percent, sx: {
                    flex: 1,
                    minWidth: 0,
                    height: 26,
                    borderRadius: '10px',
                    overflow: 'hidden',
                    backgroundColor: alpha(primary, 0.3),
                    '& .MuiLinearProgress-bar': {
                        borderRadius: '8px',
                        backgroundColor: primary,
                        minWidth: percent > 0 ? '4px' : 0
                    }
                } }), _jsxs(Typography, { variant: 'caption', sx: { color: theme.palette.common.grey.dark, flexShrink: 0, pl: '12px' }, children: [percent, "%"] })] }));
};
export default CapacityProgressBar;
